export enum ActionCode {
  Initiate = 1,
  Save = 2,
  Cancel = 3,
  Close = 4,
  PickTask = 5,
  ReleaseTask = 6,
  AssignTask = 7,
  Approve = 8,
  Reject = 9,
  RequireClarification = 10,
  WSCreateTask = 11,
  InitiatePayment = 12,
  SuccessfulPayment = 13,
  FailedPayment = 14,
  Update = 15,
  UploadDocument = 16,
  OriginalDocumentsReceived = 17,
  AlreadyCoveredByInsuranceCompany = 18,
  InformMission = 19,
  Ignore = 20,
  RouteToConcernedDepartment = 21,
  RouteToConcernedMission = 22,
  NationalAffairsDepartmentWillOwn = 23,
  Resolve = 24,
  RouteToNationalAffairs = 25,
  LogReply = 26,
  ItemFound = 27,
  ItemNotFound = 28,
  ItemFoundUAE = 29,
  SendCertificate = 30,
  Ready = 31,
  UpdateApplicatntWithChanges = 35,
  ReserveAppointment = 40,
  PayAfterAppointment = 41,
  InitiateDelivery = 42,
  UploadAttachments = 43,
  BackToRequest = 44,
  AddMembers = 45,
  PayAfterDeliveryinfo = 47
}
